export default __webpack_public_path__ + "static/media/Carro.ac4c9518.svg";